var map = {
	"./DeepLearning.png": 8817,
	"./contact.png": 9755,
	"./deeplearning.jpg": 3629,
	"./deeplearning_ai_logo.png": 2862,
	"./developerActivity.svg": 6715,
	"./education.svg": 855,
	"./experience.svg": 9917,
	"./feelingProud.svg": 658,
	"./freelance.jpg": 8608,
	"./github_logo.png": 9551,
	"./google_logo.png": 5927,
	"./gssoc.png": 1382,
	"./images (1).svg": 9390,
	"./jsFramework.svg": 8446,
	"./paper.png": 7371,
	"./pgc.png": 5436,
	"./projects-img.svg": 5985,
	"./projects_image.svg": 4716,
	"./publications.jpg": 9971,
	"./researcher.svg": 1840,
	"./ssoc.png": 6669,
	"./stanford_logo.png": 7137,
	"./sti-job.png": 8304,
	"./sti.jpg": 3959,
	"./ui_ux_design.svg": 2337,
	"./uos-logo.png": 4899,
	"./usog.jpg": 7715
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1106;